import DimpleLowcodeLayout from './src/DimpleLowcodeLayout.vue'
DimpleLowcodeLayout.install = () => {}
export { DimpleLowcodeLayout }
